
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'

import privacyPolicyDialog from "./agreement/privacyPolicyDialog";
import { wxProAdToTargetMx } from "@/mixins/wxProAd";
import {
IdentityCodeValid,
DealPasswordValid,
PasswordValid,
MobileValid,
setSStore,
setLStore,
getSStore,
IsValid,
saveToken,
isCjWxChannel,
getRoutePage,
hashQuery,
} from "@js/public/mUtils";
import { IptFocus } from "@js/public/animation";
import * as myCode from "@js/public/code";
export default {
components: {
Group,
Cell,
XInput,
XButton,
privacyPolicyDialog,
CheckIcon
},
name: "Login",
mixins: [wxProAdToTargetMx],
data() {
return {
agreePrivacy:false,
main: false, // 界面显示
canRegister: true, // 是否可以注册
passwordType: "password", // 密码显示类型
bindFlag: false, // 是否绑定微信号标志
from: {

identityNo: "",
identityValue: "",
passwordValue: "",
},
sendFrom: {

identityNo: "",
pwd: "",
source: "",
},
source: "",
comFundRiskTipFlag: false, // 是否显示
code: '',
appid: '',
appUrl: ''
};
},
created() {},
mounted() {



if(getSStore('sccode') == null) {
setSStore('sccode','wx_gzh')
}
if(getSStore('source') == null) {
setSStore('source','wx')
}
/* 获取渠道，默认微信渠道 */
if (IsValid(getSStore("source"))) {
this.source = getSStore("source");
} else {
this.source = "wx";
}

this.getCode()

},
activated() {
/* 获取渠道，默认微信渠道 */
if (IsValid(getSStore("source"))) {
this.source = getSStore("source");
} else {
this.source = "wx";
}

this.getCode()
},
methods: {
changeAgreePrivacy(){
this.agreePrivacy = !this.agreePrivacy
},

getCode() {
if (window.location.hostname == "wxzxtest2.cjhxfund.com") {
this.appid = 'wx49dab91529d1ad19'
this.appUrl = 'http://wxzxtest2.cjhxfund.com/weixin/index.html'
} else if(window.location.hostname == "wxstg1.cjhxfund.com") {
this.appid = 'wxc41ed06fa6196831'
this.appUrl = 'https://wxstg1.cjhxfund.com/weixin/index.html'
} else if(window.location.hostname == "wx.cjhxfund.com") {
this.appid = 'wx6b54b2e174089d8e'
this.appUrl = 'https://wx.cjhxfund.com/weixin/index.html'
} else {
this.appid = 'wxc41ed06fa6196831'
this.appUrl = 'https://wxstg1.cjhxfund.com/weixin/index.html'
}
const token = getSStore("token") || ''


console.log("token",token)
if (token != '') {
this.autoLogin();
} else {

if(this.is_weixn()){
this.weixinLogin();
}else{
this.autoLogin();
}






}

},
weixinLogin(){
let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appid}&redirect_uri=${encodeURIComponent(this.appUrl)}&response_type=code&scope=snsapi_base&state=STATE&connect_redirect=1#wechat_redirect`;
this.code = this.getUrlCode().code;

if (this.code == null) {
window.location.href = url;
}else{


setLStore("oauthCode",this.code)
this.autoLogin();
}
},

getUrlCode() {
var url = location.search;
var theRequest = new Object();
if (url.indexOf("?") !== -1) {
var str = url.substr(1)
var strs = str.split("&");
for (var i = 0; i < strs.length; i++) {
theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1])
}
}
return theRequest;
},
is_weixn(){
var ua= window.navigator.userAgent.toLowerCase();
console.log(ua)
if( ua.includes('wxwork') ){
console.log("---xx--企业微信浏览器")
return false;
}else if(ua.includes('micromessenger') ){
console.log("---xx--微信浏览器")
return true;
}
return false;
},

saveIp() {
let token = getSStore("token");
let params = {
ipAddr: null,
macAddr: null,
businType: "登录",
token: token,
};
this.$http.post("/suppleCustomer/addCustomerIp", params).then((res) => {
if (res.code === 0) {
}
});
},
/**
* 自动登录
* @return {[type]}
*/
autoLogin() {

if (this.$store.state.logined) {
this.saveIp();


if (this.wxProAdToTarget()) {
return;
}
if (!isCjWxChannel() && getRoutePage()) {
this.toPage(getRoutePage(), {});
} else {
if (this.source === "wx") {
setTimeout(() => {
this.toPage("comeIn/home", {});
},1000)

} else if (this.source === "yx") {
this.toPage("/buy", {});
}
}
} else {
if (isCjWxChannel()) {
this.$http.post("/customer/login/openid", {
source: this.source,
}).then((res) => {
const union_id = res.body.unionid ? res.body.unionid : res.body.openid;

this.sa.identify(union_id, true);

this.sa.setProfile({
union_id: res.body.unionid,
open_id: res.body.openid,
});



if (res.code === 0) {
setLStore("OPENID",res.body.openid)
setLStore("UNIONID",res.body.unionid)
saveToken(res.body.token);
setSStore("xhcWl", res.body.xhc_wl);
setLStore("oauthCode",'')

this.saveIp();
if (this.wxProAdToTarget()) {
return;
}
if (this.source === "wx") {
setTimeout(() => {
this.toPage("comeIn/home", {});
},1000)
} else if (this.source === "yx") {
this.toPage("/buy", { fundCode: this.$route.query.fundCode });
}
} else if (res.code === myCode.OFF_LINE) {

this.canRegister = false; 
this.main = true;
this.sendFrom.identityNo = res.message; 
this.from.identityNo = this.packIdentity(res.message); 
this.bindFlag = true;
} else if (res.code === myCode.NO_ACCOUNT) {

this.main = true;
this.bindFlag = true;
} else {
if (res.body.openid) setSStore("openid", res.body.openid);
this.main = true;
}
});
} else {
this.main = true;
}
}
},

checkCertValid() {
this.$http
.post("/suppleCustomer/checkCertValid", { token: getSStore("token") })
.then((res) => {
if (res.body.certValid === "0") {
this.$vux.toast.show({
type: "text",
text: "您尚未进行身份认证，请前往个人中心认证！",
});
this.toPage("/personal", {});
} else if (res.body.certValid === "2") {
this.$vux.toast.show({
type: "text",
text: "您身份认证已过期，请前往个人中心重新认证！",
});
this.toPage("/personal", {});
}
});
},

getInfoIsFull() {
return this.$http.post("/customer/state", {}).then((res) => {
const _this = this;
if (res.code === 0) {
this.$store.state.isCertVaild = res.body.certValid || "1";
if (!res.body.state) {
this.$vux.confirm.show({
content:
res.body.message ||
"个人信息不全，请在[个人中心]->[设置]->[个人信息]中补齐",
onConfirm() {
if (getSStore("source") === "yx") {
_this.toPage("/personal", {});
} else {
_this.toPage("/personal", {});
}
},
onCancel() {
setTimeout(() => {
this.toPage("comeIn/home", {});
},1000)

},
});
}
return true;
}
});
},
/**
* 发送
* @return {[type]}
*/















sendMessage() {
this.$vux.loading.show("加载中...");
let url;
let params;
if (this.sendFrom.identityNo.length > 11) {
url = "identityNo";
params = this.sendFrom;
} else {
url = "mobile";
params = {
mobile: this.sendFrom.identityNo,
pwd: this.sendFrom.pwd,
source: this.sendFrom.source,
};
}
return this.$http.post("/customer/login/" + url, params).then((res) => {
this.$vux.loading.hide();
if (res.code === 0) {

this.sa.track('login', {
is_success: true
})

setSStore("token", res.body.token);
setLStore("token", res.body.token);
setSStore("xhcWl", res.body.xhc_wl);
setLStore("headerToken",res.body.token)

this.$store.state.logined = true;
if (isCjWxChannel()) {
this.$store.state.userOpenIdInfo.account = this.from.identityNo; 
}
} else if (res.code === myCode.NO_ACCOUNT) {

this.sa.track('login', {
fail_reason: res.message
})

this.$vux.alert.show(res.message);
} else {

this.sa.track('login', {
fail_reason: res.message
})

}
return res;
});
},
/**
* 加密的身份证变化时的逻辑， 清空
* @param  {[string]}
* @return {[type]}
*/
changeIdentity(val) {
if (this.bindFlag) {
if (val.length !== this.sendFrom.identityNo.length) {

this.from.identityNo = "";
this.bindFlag = false;
}
}
},
/**
* 加密显示的身份证, 除了前后4位其他用*号隐藏
* @param  {[string]}
* @return {[string]}
*/
packIdentity(val) {
var result = val.slice(0, 4);
for (var i = 0; i < val.length - 8; i++) {
result += "*";
}
return (result += val.slice(val.length - 4, val.length));
},
check() {},
/**
* 点击焦点动画效果显示蓝色标题
* @param  {[string]}
* @return {[type]}
*/
onFocus(name) {
IptFocus(document.getElementById(name));
},
/**
* 提交事件
* @return {[type]}
*/
postMessage() {
var sb = document.getElementById("showBox");
sb.focus();
this.showBox = !this.showBox;
setTimeout(() => {
sb.blur();
}, 100);
setTimeout(() => {

if (!this.checkData()) return;

this.changeData();

this.sendMessage().then((res) => {
if (res.code === 0) {
this.saveIp();
saveToken(res.body.token);

if (this.wxProAdToTarget()) {
return;
}
if (!isCjWxChannel() && getRoutePage()) {
if ((getSStore("onlyFunCode") && getSStore("onlyFunCode") !== '') || (getSStore("onlyLoginId") && getSStore("onlyLoginId") !== '')) {
if (getSStore("onlyFunCode") && getSStore("onlyFunCode") !== '') {
this.toPage("/productDetail", { fundCode: getSStore("onlyFunCode") });
}
if (getSStore("onlyLoginId") && getSStore("onlyLoginId") !== '') {
this.toPage("/jdDrainage", {});
}
} else {
this.toPage(getRoutePage(), {});
}
} else {
if (this.source === "wx") {
setTimeout(() => {
if ((getSStore("onlyFunCode") && getSStore("onlyFunCode") !== '') || (getSStore("onlyLoginId") && getSStore("onlyLoginId") !== '')) {
if (getSStore("onlyFunCode") && getSStore("onlyFunCode") !== '') {
this.toPage("/productDetail", { fundCode: getSStore("onlyFunCode") });
}
if (getSStore("onlyLoginId") && getSStore("onlyLoginId") !== '') {
this.toPage("/jdDrainage", {});
}
} else {
this.toPage("comeIn/home", {});
}
},1000)

} else if (this.source === "yx") {

this.toPage("/" + getSStore("from"), {});
}
}
}
});
}, 200);
},
/**
* 验证数据格式
* @return {[boolean]}
*/
checkData() {
if (!this.bindFlag) {


if (!IsValid(this.from.identityNo)) {

this.$vux.alert.show("请输入手机号/身份证号码！");
return false;
}
if (
!MobileValid(this.from.identityNo) &&
!IdentityCodeValid(this.from.identityNo)
) {

this.$vux.alert.show("请输入正确的身份证/手机号码");
return false;
}
}
if (!IsValid(this.from.passwordValue)) {
this.$vux.alert.show("请输入登录密码！");
return false;
}
if (!this.from.passwordValue) {
this.$vux.alert.show("登录密码不能为空");
return false;
}
if (
this.from.passwordValue.length < 6 ||
this.from.passwordValue.length > 16
) {
this.$vux.alert.show("登录密码格式不正确");
return false;
}
if(!this.agreePrivacy){
this.$vux.alert.show("请先阅读并同意隐私政策");
return false;
}
return true;
},
/**
* 转换数据
* @return {[type]}
*/
changeData() {

if (!this.bindFlag) {
this.sendFrom.identityNo = this.from.identityNo;
}
this.sendFrom.pwd = this.from.passwordValue;
this.sendFrom.source = this.source; 
},

/**
* 切换密码显示方式
* @return {[type]}
*/
pwdChangeShow() {
this.passwordType =
this.passwordType === "password" ? "text" : "password";
},












toRegister() {






this.toPage("/registerNew", {});
},

toForgetPwd() {
this.toPage("/forgetNew", {});
},
},
};



// WEBPACK FOOTER //
// ./src/components/login/login.vue